import { RuleActionTypes } from '@/pages/Products/CloudFlare/ManageCloudFlareHandler/components/Security/Security.types';
import { FEATURES } from '@/pages/Products/CloudFlare/ManageCloudFlareHandler/ManageCloudFlareHandler.types';
import { format } from 'date-fns';
import { Button, Link } from 'gatorcomponents';
import React from 'react';

export default {
  title: 'CDN - Desempenho de sites',
  hostingLabel: 'Hospedagem: ',
  change: 'Alterar',
  cloudflareCdnExplanation: ({ handleWhatIsCdn }) => (
    <>
      {'Acelere seu site e tenha mais segurança ao ativar a CDN integrada a Cloudflare. '}
      <Button
        variant="text"
        label="O que é CDN?"
        onClick={handleWhatIsCdn}
      />
    </>
  ),
  searchPerDomain: 'Pesquisar por domínio',
  activateCdn: 'Ativar CDN',
  status: {
    nonexistentexternal: 'Pendente',
    pendinginternal: 'Em andamento',
    pendingexternal: 'Verificando configuração',
    error: 'Erro na configuração',
    delayinternal: 'Erro na configuração',
    delayexternal: 'Erro na configuração',
    activationpointingerrorinternal: 'Em andamento',
    activationpointingerrorexternal: 'Verificando configuração',
    pendingdeactivationinternal: 'Em andamento',
    pendingdeactivationexternal: 'Em andamento',
    inactivationpointingerrorinternal: 'Em andamento',
    inactivationpointingerrorexternal: 'Verificando configuração',
    externalproviderinternal: 'Em andamento',
  },
  manage: 'Gerenciar',
  externalDomain: 'Domínio não registrado na HostGator. Ative o botão e siga as instruções para configurá-lo no provedor de origem.',
  cantActivate: 'Não é possível alterar a CDN enquanto a ativação está em andamento',
  ongoingActivation: (
    <>
      {'A CDN será ativada automaticamente após a configuração do domínio. Isso pode levar até 72 horas. '}
      <Link
        text="Entenda o prazo."
        href="https://suporte.hostgator.com.br/hc/pt-br/articles/30812694986771-O-que-%C3%A9-propaga%C3%A7%C3%A3o"
        target="_blank"
      />
    </>
  ),
  ongoingExternalActivation: 'Por favor, aguarde. Assim que a ativação for concluída, você poderá usar a CDN.',
  ongoingDeactivation: (
    <>
      {'A CDN será desativada automaticamente. Isso pode levar até 72 horas. '}
      <Link
        text="Entenda o prazo."
        href="https://suporte.hostgator.com.br/hc/pt-br/articles/30812694986771-O-que-%C3%A9-propaga%C3%A7%C3%A3o"
        target="_blank"
      />
    </>
  ),
  noDomains: 'Nenhum resultado encontrado para sua busca',
  pendingTooltip: 'Não é possível alterar a CDN enquanto a ativação está em andamento',
  cdnAlreadyActive: (
    <span>
      <strong>
        A CDN
      </strong>
      {' já está ativa nesse site, deixando-o mais rápido e seguro.'}
    </span>
  ),
  showMore: 'Mostrar mais',
  changePlanModal: {
    title: 'Selecione um domínio',
    searchPlaceholder: 'Buscar por domínio',
    mainDomain: 'Domínio principal',
    back: 'Voltar',
    continue: 'Continuar',
  },
  activateDeactivateInternalModal: {
    toActivateTitle: 'Ativar a CDN',
    toDeactivateTitle: 'Desativar a CDN',
    activatingTitle: 'Ativação da CDN em andamento',
    deactivatingTitle: 'Desativação da CDN em andamento',
    toActivateDescription: 'Ative a CDN e deixe seu site mais rápido e seguro. As mudanças podem levar até 24 horas.',
    toDeactivateDescription: 'Desativar a CDN pode deixar seu site mais lento e menos seguro. As mudanças podem levar até 24 horas.',
    activatingDescription: 'A ativação da sua CDN foi solicitada e está em andamento. Acompanhe a atualização do status na tela de gerenciamento.',
    deactivatingDescription: 'A desativação da sua CDN foi solicitada e está em andamento. Acompanhe a atualização do status na tela de gerenciamento.',
    cancelCta: 'Cancelar',
    confirmationCta: 'Ok, entendi',
    continueActivationCta: 'Ativar a CDN',
    continueDeactivationCta: 'Desativar a CDN',
    failedRequestTitle: 'Ocorreu um erro na sua solicitação',
    failedRequestDescription: 'Algo deu errado enquanto processavamos sua solicitação. Por favor, tente novamente.',
    domainWithProblemTitle: 'Domínio temporariamente indisponível',
    domainWithProblemDescription: 'Não foi possível ativar a CDN por conta de problemas no seu domínio, por favor, entre em contato com o seu registrante e confirme se há alguma pendência.',
  },
  nameServerTooltip: (ns1, ns2) => (
    <>
      <strong>
        {'Servidor 1: '}
      </strong>
      {ns1}
      <br />
      <strong>
        {'Servidor 2: '}
      </strong>
      {ns2}
    </>
  ),
  refreshStatus: 'Atualizar status da listagem',
  noOpenStatus: 'Você não possui status em aberto',
  waitRefreshTimeLimit: 'Aguarde até 1 hora para atualizar o status novamente',
  domainsError: 'Ocorreu um problema ao processar sua solicitação. Caso persista, tente novamente mais tarde.',
  refreshList: 'Recarregar lista',
  messageWithActivationError: 'Ocorreu um erro na sua configuração. Tente novamente, e se o problema continuar, contate o suporte.',
  messageWithDeactivationError: 'Ocorreu um erro na sua tentativa de desativação da CDN. Tente novamente, e se o problema continuar, contate o suporte.',
  genericErrorModal: {
    title: 'Ocorreu um erro na sua solicitação',
    description: 'Algo deu errado enquanto processávamos sua solicitação. Por favor, tente novamente.',
    buttonLabel: 'Ok, entendi',
  },
  genericSuccessModal: {
    title: 'Sua alteração foi realizada com sucesso.',
    description: '',
    buttonLabel: 'Ok, entendi',
  },
  deleteRuleConfirmModal: {
    title: 'Tem certeza que deseja excluir essa regra de bloqueio?',
    description: '',
    primaryButtonLabel: 'Sim, quero excluir',
    secondaryButtonLabel: 'Cancelar',
  },
  deleteRuleSuccessModal: {
    title: 'Sua regra de bloqueio foi excluída com sucesso.',
    description: '',
    buttonLabel: 'Ok, entendi',
  },
  blockingErrorModal: {
    title: 'Ocorreu um erro em seu bloqueio',
    description: 'Houve um problema em sua tentativa de bloqueio. Por favor, tente novamente.',
    buttonLabel: 'Ok, entendi',
  },
  manageCdnHandler: {
    hostingLabel: planName => `Hospedagem: ${planName}`,
    selectedDomainLabel: 'Domínio selecionado',
    changeButtonLabel: 'Alterar',
    readMoreButton: toggleOn => (toggleOn ? 'Ler menos' : 'Ler mais'),
    footerLabel: 'Essas funcionalidades utilizam os recusos da Cloudflare',
    cdnCards: {
      [FEATURES.PURGE_CACHE]: {
        cardTitle: 'Limpar cache',
        cardDescription: 'Apague os arquivos em cache para forçar o sistema a buscar uma nova versão desses arquivos do seu servidor web. Limpar o cache pode fazer com que o seu site fique mais lento temporariamente e sobrecarregar o seu servidor.',
        button: {
          buttonLabel: 'Limpar cache',
          secondsRemainingTooltip: ({ seconds }) => (
            <>
              {'Aguarde '}
              {seconds}
              {seconds > 1 ? ' segundos' : ' segundo'}
              {' para limpar cache novamente'}
            </>
          ),
        },
      },
      [FEATURES.DEV_MODE]: {
        cardTitle: 'Visualizar mudanças no site em tempo real',
        cardDescription: 'Desativa temporariamente alguns recursos como armazenamento em cache, compressão e otimização de arquivos, por três horas (a menos que você os desative antes).  Isso permite que você veja imediatamente qualquer mudança que faça no seu site.',
        tooltipLabel: (
          <>
            {'Essa funcionalidade utiliza o '}
            <strong>modo desenvolvedor</strong>
            {' da Cloudflare'}
          </>
        ),
        secondsRemainingTooltip: ({ seconds, isActive }) => (
          <>
            {'Aguarde '}
            {seconds}
            {seconds > 1 ? ' segundos' : ' segundo'}
            {' para '}
            {isActive ? 'desativar' : 'ativar'}
            {' essa funcionalidade novamente'}
          </>
        ),
      },
      [FEATURES.UNDER_ATTACK_MODE]: {
        cardTitle: 'Modo sob ataque',
        cardDescription: 'Faz verificações extras para proteger seu site contra ataques de vírus. Ele permite o bloqueio do tráfego suspeito. Use este modo quando seu site estiver sendo atacado. Quando ativado, os visitantes verão uma página de espera antes de acessar o site.',
        secondsRemainingTooltip: ({ seconds, isActive }) => (
          <>
            {'Aguarde '}
            {seconds}
            {seconds > 1 ? ' segundos' : ' segundo'}
            {' para '}
            {isActive ? 'desativar' : 'ativar'}
            {' essa funcionalidade novamente'}
          </>
        ),
      },
      [FEATURES.ALWAYS_ONLINE]: {
        cardTitle: 'Manter site sempre online',
        cardDescription: 'Mantenha o seu site acessível mesmo quando o servidor estiver fora do ar. Essa função usa cópias das suas páginas guardadas no Wayback Machine (serviço online que arquiva e permite visualizar versões antigas de sites da internet).',
        tooltipLabel: (
          <>
            {'Essa funcionalidade utiliza o '}
            <strong>always online</strong>
            {' da Cloudflare'}
          </>
        ),
        secondsRemainingTooltip: ({ seconds, isActive }) => (
          <>
            {'Aguarde '}
            {seconds}
            {seconds > 1 ? ' segundos' : ' segundo'}
            {' para '}
            {isActive ? 'desativar' : 'ativar'}
            {' essa funcionalidade novamente'}
          </>
        ),
      },
    },
    cleanCacheModal: {
      successTitle: 'Limpeza de cache realizada',
      successDescription: 'Seu site será atualizado com a última versão disponível no servidor original.',

      failureTitle: 'Ocorreu um erro ao limpar o cache',
      failureDescription: 'Houve um problema ao tentar limpar o cache. Por favor, tente novamente.',

      loadingTitle: 'Limpeza de cache em andamento',
      okButtonLabel: 'Ok, entendi',
    },
    cleanCacheModalError: {
      title: 'Ocorreu um erro ao limpar o cache',
      description: 'Houve um problema ao tentar limpar o cache. Por favor, tente novamente.',
      buttonLabel: 'Ok, entendi',
    },
    tabs: {
      speed: 'Teste de velocidade',
      visitors: 'Visitantes',
      tools: 'Ferramentas',
      security: 'Segurança',
    },
    speedAnalysis: {
      title: 'Teste de velocidade',
      listTitle: 'Detalhes do desempenho de seu site',
      firstRow: `Faça o teste de velocidade para analisar o tempo de carregamento das páginas, identificando possíveis problemas
de desempenho. Tenha uma maior taxa de conversão ao garantir um site mais rápido e eficiente.`,
      secondRow: 'Você pode realizar até 30 testes por mês. Após atingir esse limite, os testes serão renovados no mês seguinte.',
      stillHave: ({ amount }) => (
        <>
          {'Você ainda possui '}
          <strong>
            {amount}
            {' testes'}
          </strong>
          {' para realizar'}
        </>
      ),
      dontHave: (
        <>
          {'Você já '}
          <strong>atingiu o limite</strong>
          {' de testes'}
        </>
      ),
      initTestLabel: 'Iniciar teste',
      reduTestLabel: 'Refazer teste',
      showList: 'Mostrar detalhes',
      hideList: 'Ocultar detalhes',
      testDate: date => `Resultado do teste: ${format(date, 'dd/MM/yyyy H:m')}`,
      results: {
        title: 'Resultado do seu teste',
        analysisTitle: {
          good: 'O site está com um rápido desempenho',
          neutral: 'O site está com um desempenho moderado',
          bad: 'Seu site está com um baixo desempenho',
        },
        failedTitle: 'Falha ao realizar seu teste',
        failedDescription: domain => `Não foi possível realizar o teste de velocidade no domínio “${domain}” Confira se esse domínio está hospedado em nosso servidor e tente novamente.`,
        videoAbout: {
          title: 'Entenda o resultado do seu teste',
          src: 'https://www.youtube.com/watch?v=eu73QC56xWg',
        },
        items: {
          ttfb: 'Tempo até o primeiro byte carregar (TTFB)',
          ttfbTooltip: 'Time to First Byte é o tempo que o seu computador demora para começar a receber as primeiras informações de um site depois  que você clica para acessá-lo. Quanto menor esse tempo, mais rápido o site  vai aparecer para você.',
          fcp: 'Tempo do primeiro conteúdo da tela aparecer (FCP)',
          fcpTooltip: ' First Contentful Paint é o momento em que você começa a ver algo útil na tela ao carregar um site. É a primeira vez que o site mostra algo que você pode ver, como texto, imagens ou gráficos. Quanto mais rápido isso acontece, mais rápido você sente que o site está carregando.',
          lcp: 'Tempo que o maior conteúdo do site aparece (LCP)',
          lcpTooltip: 'Largest Contentful Paint é quando o maior e mais relevante pedaço de conteúdo  aparece na tela, como uma grande imagem, um vídeo ou um bloco de texto principal.  Quanto mais rápido isso acontece, mais  rápido você sente que o site terminou de carregar o conteúdo principal.',
          tti: 'Tempo para o site estar pronto para uso (TTI)',
          ttiTooltip: 'Time to Interactive é o tempo que o site leva para estar pronto para ser usado,  isso significa o tempo que ele leva para não apenas aparecer, mas estar totalmente pronto para você interagir com ele, sem travar ou demorar para responder.',
          tbt: 'Tempo de travamento durante o carregamento (TBT)',
          tbtTooltip: 'Total Blocking Time mede o tempo em que o site está travado e não responde a interações, como cliques ou digitação. É o período em que ele está carregando ou processando algo e não responde a você imediatamente. Quanto menor esse tempo, mais fluida é a experiência de uso.',
          si: 'Velocidade com que o conteúdo visível do site aparece (SI)',
          siTooltip: 'Speed Index é uma medida de quão rápido o conteúdo visível de um site aparece enquanto ele está carregando. É uma forma de medir quão rapidamente você vê a página ganhando forma e se tornando útil, mesmo que ainda não esteja carregando completamente. Quanto menor o índice, mais rápido você vê o site se tornando visível.',
          cls: 'Estabilidade visual da página ao carregar (CLS)',
          clsTooltip: 'Cumulative Layout Shift mede o quanto o conteúdo de um site muda de lugar enquanto ele está carregando. Para um site, é quando o texto ou as imagens mudam de posição enquanto você está tentando interagir com a página. Quanto menor a mudança, mais estável e confortável é a experiência de uso.',
        },
      },
      historyList: {
        title: 'Histórico de resultados',
        date: 'Data',
        domain: 'Domínio',
        score: 'Pontuação',
        showDetails: 'Mostrar detalhes',
        itemsPerPage: 'Itens por página: ',
      },
      getHistoryListError: {
        title: 'Falha ao carregar os dados',
        description: 'Não foi possível carregar os dados solicitados. Por favor, aguarde e tente novamente em alguns minutos.',
      },
    },
    progressBar: {
      texts: [
        'Iniciando...',
        'Analisando o site...',
        'Gerando o relatório...',
      ],
    },
    visitors: {
      visitsOnSiteTitle: 'Visitas no site',
      totalOfAccess: 'Total de acessos',
      maxOfVisitants: 'Máximo de visitantes únicos',
      minOfVisitants: 'Mínimo de visitantes únicos',
      perDay: 'Por um dia',
      perHour: 'Por uma hora',
      uniqueVisitants: 'Visitantes únicos',
      startTimeEndTime: (startTime, endTime) => `De ${startTime}\nAté ${endTime}`,
      selectOptions: {
        last24hours: '24 horas anteriores',
        last7Days: '7 dias anteriores',
        last30Days: '30 dias anteriores',
      },

      regionsOfAccessTitle: 'Principais países/regiões de acesso',
      countryTitle: 'País/Região',
      trafficTitle: 'Tráfego',
      perPageLabel: 'Itens por página',
      noDataTitle: 'Ainda não há dados para exibir',
      noDataDescription: 'Seu site ainda não possui dados de visitas para exibir.',
      errorStateTitle: 'Falha ao carregar os dados',
      errorStateDescription: 'Não foi possível carregar os dados solicitados. Por favor, aguarde e tente novamente em alguns minutos.',
    },
    security: {
      rules: {
        title: 'Nome da regra',
        description: 'Coloque a sua regra um nome descritivo',
        inputLabel: 'Ex: regra de bloqueio por país duplicada *',
        ruleBlockedUntil: (isEnabled, seconds) => `Você poderá ${isEnabled ? 'desativar' : 'ativar'} esta regra novamente em ${seconds} segundos`,
        createRuleBlockedUntil: seconds => `Você poderá criar uma nova regra em ${seconds} segundos`,
        editRuleBlockedUntil: seconds => `Por favor, aguarde. Você poderá editar esta regra novamente em ${seconds} segundos`,
        noChanges: 'Altere ao menos um campo para salvar a edição da regra',
      },
      traficBlock: {
        title: 'Bloqueio de tráfego',
        description: 'Selecione o que deseja bloquear',
        selectPlaceholder: 'Selecionar',
        rulesLeftInfo: rulesLeft => (
          <span>
            Você possui
            {' '}
            <strong>
              {rulesLeft}
              {' '}
              {rulesLeft === 1 ? 'regra' : 'regras'}
            </strong>
            {' '}
            de bloqueio
            {' '}
            {rulesLeft === 1 ? 'disponível' : 'disponíveis'}
          </span>
        ),
        noRulesLeftInfo: () => (
          <span>
            Você já atingiu o
            {' '}
            <strong>limite de 5 regras</strong>
            {' '}
            de bloqueio criadas, para continuar exclua uma delas na lista de bloqueios.
          </span>
        ),
        ruleTypes: {
          [RuleActionTypes.COUNTRY]: {
            label: 'País',
            ruleValuePlaceholder: 'Selecionar país',
          },
          [RuleActionTypes.CONTINENT]: {
            label: 'Continente',
            ruleValuePlaceholder: 'Selecionar continente',
          },
          [RuleActionTypes.SOURCE_IP_ADDRESS]: {
            label: 'Endereço por IP',
            ruleValuePlaceholder: 'Endereço de IP, ex: 192.158.1.38',
          },
          [RuleActionTypes.URL]: {
            label: 'Endereço do site - URL',
            ruleValuePlaceholder: 'URL exemplo: www.meusite.com.br',
          },
        },
        button: 'Bloquear',
      },
      blockList: {
        title: 'Lista de bloqueios',
        order: 'Ordem',
        name: 'Nome',
        action: 'Ação',
        toggleOn: 'Habilitado',
      },
      dropdownActions: {
        edit: 'Editar',
        duplicate: 'Duplicar',
        delete: 'Excluir',
      },
      addRuleModalSuccess: {
        title: 'Seu bloqueio foi realizado com sucesso',
        description: rulesLeft => (
          <>
            <div>
              Confira os detalhes da ação na sua lista de bloqueios.
            </div>
            <div>
              Você ainda possui
              {' '}
              <strong>
                {rulesLeft}
                {' '}
                {rulesLeft === 1 ? 'regra' : 'regras'}
                {' '}
              </strong>
              {' '}
              {`de bloqueio ${rulesLeft === 1 ? 'disponível' : 'disponíveis'}`}
            </div>
          </>
        ),
        buttonLabel: 'Ok, entendi',
      },
      getRulesError: {
        title: 'Falha ao carregar os dados',
        description: 'Não foi possível carregar os dados solicitados. Por favor, aguarde e tente novamente em alguns minutos.',
      },
    },
  },
  cloudflareBanner: {
    title: 'Deixe seu site mais rápido e seguro com a CDN da Cloudflare',
    description: 'Acelere o tempo de carregamento do seu site, proporcionando uma experiência mais rápida e satisfatória para os seus visitantes grátis.',
    buttonCta: 'Ir para desempenho de sites',
  },
  topBanner: {
    title: 'Seu site mais rápido e seguro com a CDN da Cloudflare grátis',
    description: 'Os sites do seu plano já tem acesso aos recursos de desempenho e segurança da CDN grátis.',
    cta: 'Conheça',
    modal: {
      title: 'Conheça a CDN da Cloudflare',
      know: {
        title: 'O que é a CDN da Cloudflare?',
        description: 'A CDN (Content Delivery Network) é uma rede de servidores distribuídos globalmente que entrega conteúdo da internet mais rápida, eficiente e segura.',
      },
      speed: {
        title: 'Maior velocidade do site',
        description: 'Com a CDN, o conteúdo do seu site é entregue a partir de servidores mais próximos dos visitantes, o que faz as páginas carregarem mais rápido.',
      },
      stability: {
        title: 'Maior estabilidade',
        description: 'Se um servidor falhar, a CDN redireciona o tráfego para uma versão do seu conteúdo em cache mantendo seu site sempre online.',
      },
      safety: {
        title: 'Maior segurança ',
        description: 'Protege o site contra ataques cibernéticos, como tentativas de derrubá-lo com tráfego excessivo (DDoS).',
      },
      settup: {
        title: 'Configure sua CDN em desempenho de sites',
        description: 'Acelere e proteja o seu site com a CDN da Cloudflare. Comece hoje e melhore sua performance online',
        cta: 'Ir para desempenho de sites',
      },
    },
  },
  whatIsCdnModal: {
    title: 'O que é a CDN',
    description: 'A CDN (Content Delivery Network) é uma rede de servidores distribuídos globalmente que entrega conteúdo da internet mais rápida, eficiente e segura. Ter uma CDN trás vantagens para o seu site como:',
    items: [
      {
        icon: 'IconCdn',
        featureBackground: 'attentionPure',
        iconSecondaryColor: 'attentionUltraLight',
        title: 'Mais velocidade',
        description: 'O conteúdo do seu site é entregue a partir de servidores mais próximos dos visitantes, o que faz as páginas carregarem mais rápido.',
      },
      {
        icon: 'IconSecurityCheck',
        featureBackground: 'activeLight',
        iconSecondaryColor: 'activeUltraLight',
        title: 'Mais segurança',
        description: 'Protege o site contra ataques cibernéticos, como tentativas de derrubá-lo com tráfego excessivo (DDoS).',
      },
      {
        icon: 'IconLive',
        featureBackground: 'pendingPure',
        iconSecondaryColor: 'attentionUltraLight',
        title: 'Maior estabilidade',
        description: 'Se um servidor falhar, a CDN redireciona o tráfego para uma versão do seu conteúdo em cache mantendo seu site sempre online.',
      },
    ],
    cta: 'Ok, entendi',
  },
};
